import { Routes } from '@angular/router';
import { authGuard } from "./_guards/auth.guard";
import { dateFeatureGuard } from "./_guards/date-feature.guard";
import { PanelComponent } from "./components/panel/panel.component";
import { LoginComponent } from "./components/auth/login/login.component";
import { NotFoundComponent } from './components/common/not-found/not-found.component';
import { ListComponent } from './components/features/lists/list/list.component';

import { FeatureComponent } from './components/features/features/feature/feature.component';
import { EntityComponent } from './components/features/entities/entity/entity.component';
import { EntityPastAndFutureComponent } from './components/features/entities/entity-past-and-future/entity-past-and-future.component';
import { InsightComponent } from './components/addons/insights/insight/insight.component';
import { AttachmentComponent } from './components/addons/attachments/attachment/attachment.component';
import { TrashComponent } from './components/features/trash/trash.component';
import { AppSettingsComponent } from './components/common/app-settings/app-settings.component';
import { ChatComponent } from './components/common/support/chat/chat.component';
import { ListPublicComponent } from './components/features/lists/list-public/list-public.component';
import { NotePublicComponent } from './components/features/notes/note-public/note-public.component';
import { FeatureGuideComponent } from './components/common/feature-guides/feature-guide/feature-guide.component';
import { AccountPublicComponent } from './components/common/account/account-public/account-public.component';
import { AccountDeletedComponent } from './components/common/account/account-deleted/account-deleted.component';
import { BlockedPageComponent } from './components/blocked/blocked-page.component';
import { FocusGameComponent } from './components/features/focus-tracker/focus-game/focus-game.component';
import { MicrosoftOAuthCallbackComponent } from './components/features/calendar-integration/microsoft-oauth-callback/microsoft-oauth-callback.component';
import { CollaboratorsPageComponent } from './components/collaborators/collaborators-page/collaborators-page.component';
import { MessageListComponent } from './components/addons/message/message-list/message-list.component';
import { FeedbackDialogComponent } from './components/shared/dialogs/feedback-dialog/feedback-dialog.component';
import { FeatureIntroComponent } from './components/common/feature-guides/feature-intro/feature-intro.component';
import { SharedDeeplinkComponent } from './components/shared-deeplink/shared-deeplink.component';
import { MeoHistoryComponent } from './components/meo/meo-history/meo-history.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent, data: { screen: 'login' } },
  { path: 'me-calendar-auth', component: MicrosoftOAuthCallbackComponent, data: { screen: 'oauth-callback' } },
  { path: 'account-deleted', component: AccountDeletedComponent, data: { screen: 'account-deleted' } },
  { path: 'blocked', component: BlockedPageComponent, data: { screen: 'blocked' } },
  // Shared deeplink route for email notifications: /shared?collection={type}&id={id}
  {
    path: 'shared',
    component: PanelComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: SharedDeeplinkComponent, data: { screen: 'shared-deeplink' } }
    ]
  },
  { path: 'list',
    component: PanelComponent,
    children: [
      { path: ':id', component: ListPublicComponent, data: { screen: 'list-public' } }
    ]
  },
  { path: 'note', component: PanelComponent,
    children: [
      { path: ':id', component: NotePublicComponent, data: { screen: 'note-public' } }
    ]
  },
  { path: 'user', component: PanelComponent,
    children: [
      { path: ':id', component: AccountPublicComponent, data: { screen: 'account-public' } }
    ]
  },
  {
    path: '',
    component: PanelComponent,
    canActivate: [authGuard],
    children: [
      { path: 'today', component: EntityComponent, canActivate: [dateFeatureGuard], data: { screen: 'today' } },
      { path: 'future', component: EntityPastAndFutureComponent, canActivate: [dateFeatureGuard], data: { screen: 'future' } },
      { path: 'past', component: EntityPastAndFutureComponent, canActivate: [dateFeatureGuard], data: { screen: 'past' } },
      { path: 'lists', component: ListComponent, data: { screen: 'lists' } },
      // Notes standalone screen removed — notes are shown in Today/Past screens.
      // Redirect old /notes URLs to /today so external links still work.
      { path: 'notes', redirectTo: 'today', pathMatch: 'full' },
      { path: 'focus-tracker/:gameLevel', component: FocusGameComponent, data: { screen: 'focus' } },
      { path: 'features', component: FeatureComponent, data: { screen: 'features' } },
      { path: 'insight', component: InsightComponent, data: { screen: 'insight' } },
      { path: 'attachment', component: AttachmentComponent, data: { screen: 'attachment' } },
      { path: 'trash', component: TrashComponent, data: { screen: 'trash' } },
      { path: 'collaborators', component: CollaboratorsPageComponent, data: { screen: 'collaborators' } },
      { path: 'messages', component: MessageListComponent, data: { screen: 'messages' } },
      { path: 'account-public', component: AccountPublicComponent, data: { screen: 'account-public' } },
      { path: 'settings', component: AppSettingsComponent, data: { screen: 'settings' } },
      { path: 'feature-guide', component: FeatureGuideComponent, data: { screen: 'feature-guide' } },
      { path: 'intro-screen', component: FeatureIntroComponent, data: { screen: 'intro-screen' } },
      { path: 'feedback', component: FeedbackDialogComponent, data: { screen: 'feedback' } },
      { path: 'meo', redirectTo: 'today', pathMatch: 'full' },
      { path: 'meo-history', component: MeoHistoryComponent, data: { screen: 'meo-history' } },
      { path: 'chat', component: ChatComponent, data: { screen: 'chat' } },
      { path: ':date', component: EntityComponent, canActivate: [dateFeatureGuard], data: { screen: 'other' } },
      { path: '', redirectTo: 'today', pathMatch: 'full', data: { screen: 'other' } }
    ]
  },
  { path: '**', component: NotFoundComponent }
];
